/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(initialState: { roleInfo?: API.RoleInfo } | undefined) {
  const { roleInfo } = initialState ?? {};

  function hasAccess(accessKey: string) {
    return roleInfo && roleInfo.permissions.findIndex((f) => f === accessKey) > -1;
  }
  // return {
  //   'managementUnit': true,
  //   'managementUnit/managementUnit': true
  // }
  const permissions = roleInfo?.permissions || [];
  const hasPermissions = {}
   permissions.forEach(item => {
    hasPermissions[item] = true
   });
  return {
    ...hasPermissions,
    // dashboard: true,
    // 'dashboard/analysis' : true,
    // system: true,
    // 'system/user': true,
  }
  return {
    xxx: hasAccess('xxx'),
  };
}
